<script>
import { percentage_format } from "@/utils.js";
export default {
  name: "demograph-chart",
  props: ["item", "items"],
  computed: {
    series() {
      return this.items[this.item].map(obj =>
        Number(obj.value)
      );
    },
    labels() {
      return this.items[this.item].map(obj => obj.tier);
    },
    chartOptions() {
      // return {
      //   labels: this.items[this.item].map(obj=> obj.tier),
      //   legend: {
      //     floating: true,
      //     position: "left",
      //     horizontalAlign: "center",
      //     width: 300,
      //     markers: {
      //       radius: 2
      //     }
      //   },
      //   chart: {
      //     width: 350,
      //     type: "donut",
      //     height: "auto",
      //     offsetY: 0,
      //     offsetX: 0
      //   },
      //   plotOptions: {
      //     pie: {
      //       customScale: 0.80,
      //       expandOnClick: false,
      //       offsetX: 10,
      //       offsetY: -20,
      //       donut: {
      //         size: "60%",
      //         labels: {
      //             show: true,
      //         },
      //       },
      //     },
      //   },
      //   fill: {
      //     type: "gradient",
      //   },
      //   title: {
      //     text: this.item,
      //     align: "center",
      //     style: {
      //       fontWeight: "bold"
      //     }
      //   },
      //   responsive: [{
      //     breakpoint: 480,
      //     options: {
      //       chart: {
      //         width: 200
      //       },
      //       legend: {
      //         position: "bottom"
      //       }
      //     }
      //   }]
      // }

      return {
        legend: {
          floating: "true",
          position: "bottom",
          horizontalAlign: "center",
          width: 370
        },
        labels: this.items[this.item].map(obj => obj.tier),
        chart: {
          width: 350,
          type: "donut",
          height: "auto"
        },
        title: {
          text: this.item,
          style: {
            fontWeight: "bold"
          }
        },
        tooltip: {
          enabled: false,
          y: {
            formatter: function(value) {
              console.log("chart value:",value);
              return `${(value/100).toFixed(2)}` + "%";
            }
          }
        },
        colors: [
          "#008FFB",
          "#4CAF50",
          "#FEB019",
          "#FF4560",
          "#1ab09d",
          "#5A2A27",
          "#fb6c00",
          "#b09d1a"
        ],
        // dataLabels: {
        //   enabled: true,
        //   formatter: function (val) {
        //     return val + "%"
        //   },
        // },
        plotOptions: {
          pie: {
            customScale: 0.65,
            expandOnClick: false,
            offsetY: -70,
            offsetX: -10,
            donut: {
              size: "60%",
              labels: {
                show: false, // this is the value at the center or pie
                value: {
                  formatter: function(value) {
                    return `${value}`;
                  }
                }
              }
            }
          }
        }
      };
    }
  }
};
</script>
<template>
  <v-card class="mx-auto" max-width="400" elevation="3">
    <!-- <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="headline text-center">
          {{ item }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item> -->
    <v-card-text>
      <apexchart
        type="donut"
        width="380"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </v-card-text>
  </v-card>
</template>
<style scoped>
.headline {
  text-transform: capitalize;
}
</style>